import React from 'react';
import Icon from '../../../../components/AppIcon';

const CountdownTimer = ({ timeLeft }) => {
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const isUrgent = timeLeft <= 60; // Last minute
  const isAlmostExpired = timeLeft <= 30; // Last 30 seconds

  return (
    <div className="text-center mb-4">
      <div className={`inline-flex items-center space-x-2 px-3 py-2 rounded-full transition-all duration-300 ${isAlmostExpired
          ? 'bg-error-50 text-error-600'
          : isUrgent
            ? 'bg-warning-50 text-warning-600' : 'bg-accent-50 text-accent-600'
        }`}>
        <Icon
          name={isUrgent ? 'AlertTriangle' : 'Clock'}
          size={16}
          className={isAlmostExpired ? 'animate-pulse' : ''}
        />
        <span className="text-sm font-medium">
          {minutes}:{seconds.toString().padStart(2, '0')}
        </span>
      </div>

      <p className={`text-xs mt-2 transition-colors duration-300 ${isAlmostExpired
          ? 'text-error-600'
          : isUrgent
            ? 'text-warning-600' : 'text-accent-500'
        }`}>
        {isAlmostExpired
          ? 'Code expires soon!'
          : isUrgent
            ? 'Code expires in less than a minute' : 'Time remaining for verification'
        }
      </p>
    </div>
  );
};

export default CountdownTimer;